var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplifiedBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 39.291 39.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6173",
    "data-name": "Group 6173",
    transform: "translate(-19.999 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19373",
    "data-name": "Path 19373",
    d: "M29.81,36.459a1.535,1.535,0,1,0-1.59-2.625,16.723,16.723,0,1,1,5.19-4.989,1.535,1.535,0,1,0,2.552,1.706A19.635,19.635,0,0,0,5.753,5.753,19.647,19.647,0,0,0,29.81,36.459Zm0,0",
    transform: "translate(20 20.001)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19372",
    "data-name": "Path 19372",
    d: "M26.551,21.178H12.738a1.535,1.535,0,1,1,0-3.07H26.551a1.535,1.535,0,0,1,0,3.07Zm1.535-7.673a1.535,1.535,0,0,0-1.535-1.535H12.738a1.535,1.535,0,1,0,0,3.07H26.551A1.535,1.535,0,0,0,28.086,13.505Zm0,12.278a1.535,1.535,0,0,0-1.535-1.535H12.738a1.535,1.535,0,1,0,0,3.07H26.551A1.535,1.535,0,0,0,28.086,25.784Z",
    transform: "translate(20 20.001)",
    fill: "#ff0185"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplifiedBox);
export default __webpack_public_path__ + "static/media/SimplifiedBox.fe67ddac9ebdc7734cf24fae20dadfaa.svg";
export { ForwardRef as ReactComponent };